// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"768928b5","787":"9631e152"}[chunkId] + ".chunk.js";
};